/* tslint:disable */
/* eslint-disable */
/**
 * CVAT REST API
 * REST API for Computer Vision Annotation Tool (CVAT)
 *
 * The version of the OpenAPI document: 2.31.0
 * Contact: support@cvat.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * * `gt` - GT * `gt_pool` - GT_POOL
 * @export
 * @enum {string}
 */

export const ValidationMode = {
    Gt: 'gt',
    GtPool: 'gt_pool'
} as const;

export type ValidationMode = typeof ValidationMode[keyof typeof ValidationMode];



